import {FC, useEffect} from "react";
import {Column} from "../../atoms/Layout.tsx";
import LogoWithTitle from "../../molecules/LogoWithTitle.tsx";
import {Text} from "../../style/typography.tsx";
import {logout} from "../../api/user.ts";
import {AUTH0_CLIENT} from "../../helpers/auth0.ts";
import {useNavigate} from "react-router";

const LogoutPage: FC = () => {
    const navigate = useNavigate();

    useEffect(() => {
        logout().then(() => AUTH0_CLIENT.logout())
            .then(() => navigate("/"))
    })

    return <Column padding="20" gap="80" centerVertically centerHorizontally grow>
        <LogoWithTitle />
        <Text role="heading" size="5" weight="regular">Signing you out</Text>
    </Column>
}

export default LogoutPage;